import React, { useState, useEffect } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import JsonSyntaxHighlighter from './JsonSyntaxHighlighter';
import { useFetch } from '../api';
import { getResources } from './SandboxApi';

function LocationRow({ location }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="rounded border border-surface-200 bg-surface-0">
      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        className="w-full flex items-center justify-between gap-2 px-2.5 py-1.5 text-left hover:bg-surface-50"
      >
        <span className="flex items-baseline gap-2 min-w-0">
          <span className="text-xs font-medium text-surface-800 truncate">
            {location.name || location.id}
          </span>
          {location.name && (
            <span className="font-mono text-[11px] text-surface-400 truncate">
              {location.id}
            </span>
          )}
        </span>
        {location.type && (
          <span className="text-[10px] uppercase tracking-wide text-surface-400 flex-shrink-0">
            {location.type}
          </span>
        )}
      </button>
      {expanded && (
        <div className="border-t border-surface-100 px-2.5 py-2 bg-surface-100/40">
          <JsonSyntaxHighlighter data={location} defaultExpandDepth={2} />
        </div>
      )}
    </div>
  );
}

// fetches and renders the bins/locations for a single warehouse via the
// nested wms/warehouses/{id}/locations endpoint — there is no flat list route
function WarehouseLocations({ warehouseId, connectionId }) {
  const trackstar = useFetch();
  const [locations, setLocations] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!warehouseId || !connectionId) return undefined;
    let cancelled = false;
    setLoading(true);
    setLocations(null);
    getResources(trackstar, connectionId, `wms/warehouses/${warehouseId}/locations`)
      .then((data) => {
        if (!cancelled) setLocations(data);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [warehouseId, connectionId]);

  if (!loading && locations === null) return null;

  return (
    <div className="border-b border-surface-100 px-5 py-3">
      <div className="text-[10px] font-medium text-surface-400 uppercase tracking-wider mb-2">
        Locations
        {locations && ` (${locations.length})`}
      </div>
      {loading && <ClipLoader size={14} color="#a8a29e" />}
      {!loading && locations && locations.length === 0 && (
        <div className="text-xs text-surface-400">No locations</div>
      )}
      {!loading && locations && locations.length > 0 && (
        <div className="space-y-1 max-h-48 overflow-y-auto">
          {locations.map((location) => (
            <LocationRow key={location.id} location={location} />
          ))}
        </div>
      )}
    </div>
  );
}

export default WarehouseLocations;
